export default __webpack_public_path__ + "static/media/single_web-xs@2x.354b925d.webp";